<template>
  <div class="col-auto d-lg-none">
    <button id="toggle-filter-button" aria-expanded="false" class="btn btn-link" @click="onClick">
      <i class="fas fa-sliders-h mr-1"></i> {{ $t('common.filter') }}
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    onClick(e) {
      this.$emit('click', e)
    },
  },
}
</script>
